import { TFunction } from 'i18next'
import { ContactField } from 'src/editor/shared/hooks/use-contact-fields'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export const contactFieldLocoKeys: Record<ContactSlugEnum, string> = {
  [ContactSlugEnum.Email]: 'website_settings.contact_slug.email',
  [ContactSlugEnum.FirstName]: 'website_settings.contact_slug.first_name',
  [ContactSlugEnum.Surname]: 'website_settings.contact_slug.last_name',
  [ContactSlugEnum.PhoneNumber]: 'website_settings.contact_slug.phone_number',
  [ContactSlugEnum.Country]: 'website_settings.contact_slug.country',
  [ContactSlugEnum.Neighborhood]: 'website_settings.contact_slug.neighborhood',
  [ContactSlugEnum.StreetAddress]:
    'website_settings.contact_slug.street_address',
  [ContactSlugEnum.StreetNumber]: 'website_settings.contact_slug.street_number',
  [ContactSlugEnum.City]: 'website_settings.contact_slug.city',
  [ContactSlugEnum.Postcode]: 'website_settings.contact_slug.postal_code',
  [ContactSlugEnum.CompanyName]: 'website_settings.contact_slug.company_name',
  [ContactSlugEnum.TaxNumber]: 'website_settings.contact_slug.tax_number',
  [ContactSlugEnum.State]: 'website_settings.contact_slug.state_province',
}

export const getContactSlugName = (slug: ContactSlugEnum, t: TFunction) =>
  t(contactFieldLocoKeys[slug])

export const getContactFieldTitle = (
  contactField: Pick<ContactField, 'fieldName' | 'slug'>,
  t: TFunction,
) => {
  const { slug, fieldName } = contactField

  if (Object.values(ContactSlugEnum).includes(slug as ContactSlugEnum)) {
    return getContactSlugName(slug as ContactSlugEnum, t)
  }

  return fieldName
}
